module.exports = __webpack_public_path__ + "assets/algoritmo_desktop_oculto.d4ebd36a.svg";